exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-button__nav-button__26ZQn{display:inline-block;padding:0;outline:none;border:none;background:none;transition:opacity .2s,visibility .2s}.nav-button__nav-button__26ZQn .nav-button__nav-text__GQz68{display:inline-block;margin:0 13px;color:-wix-colors-textColor;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.nav-button__nav-button__26ZQn .nav-button__nav-arrow__2Z8JX{width:30px;height:9px;fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn:hover{opacity:.7}.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx,.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx:hover{visibility:hidden;opacity:0}.nav-button__nav-button__26ZQn+.nav-button__nav-button__26ZQn{margin-left:10px}.nav-button__nav-button__26ZQn polygon{fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn.nav-button__prev__24p06 .nav-button__nav-arrow__2Z8JX{transform:rotate(180deg)}.nav-button__nav-button__26ZQn.nav-button__next__1rwow{direction:rtl}", ""]);

// exports
exports.locals = {
	"nav-button": "nav-button__nav-button__26ZQn",
	"navButton": "nav-button__nav-button__26ZQn",
	"nav-text": "nav-button__nav-text__GQz68",
	"navText": "nav-button__nav-text__GQz68",
	"nav-arrow": "nav-button__nav-arrow__2Z8JX",
	"navArrow": "nav-button__nav-arrow__2Z8JX",
	"disabled": "nav-button__disabled__3wnrx",
	"prev": "nav-button__prev__24p06",
	"next": "nav-button__next__1rwow"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/videos-list/nav-button/nav-button.styl
// module id = 2929
// module chunks = 1